import { isDefined } from "@perxis-auto/shared/lib/lib/is";
const formatGroupedFilterValue = (otherGroupedFilterItems) => {
  const otherValue = otherGroupedFilterItems.reduce((acc, item) => {
    if (!Array.isArray(item.value)) {
      return acc;
    }
    return [...acc, ...item.value];
  }, []);
  return (value) => {
    const allValue = [...otherValue];
    if (Array.isArray(value)) {
      allValue.push(...value);
    } else if (isDefined(value)) {
      allValue.push(value);
    }
    const isEmptyArray = Array.isArray(allValue) && !allValue.length;
    if (isEmptyArray) {
      return;
    }
    return allValue;
  };
};
export {
  formatGroupedFilterValue
};
